import { SSVIntlApi } from './baseHttp';

// ===== S大会配置接口 =====

// 获取大会主题配置
export function getConferenceTheme() {
  return SSVIntlApi.get('/openTechPortalWebAPI/techforgood/conference/theme');
}

// 获取大会亮点列表
export function getConferenceHighlights() {
  return SSVIntlApi.get('/openTechPortalWebAPI/techforgood/conference/highlights');
}

// 获取品牌营销内容
export function getConferenceBrands() {
  return SSVIntlApi.get('/openTechPortalWebAPI/techforgood/conference/brands');
}

// 预约直播
export function reserveLive() {
  return SSVIntlApi.post(
    '/portalWebAPI/techforgood/activity/live/reserve',
    {},
    { errorMessage: false }
  );
}

// 报名接口
export function registerForum(params = {}) {
  return SSVIntlApi.post(
    '/portalWebAPI/techforgood/activity/registration/forum',
    params
  );
}
